import React, { Component } from "react";
import MetaDecorator from "../../services/MetaDecorator";
import sharepoint from "../../../media/images/sharepoint.jpg";
import sharepointMobile from "../../../media/images/sharepointMobile.jpg";

export default class SharePoint extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth,
    };
  }
  componentDidMount = () => {
    let tabs = document.getElementsByClassName("nav-wrapper");
    if (tabs.length > 0) {
      tabs = tabs[1].querySelectorAll("ul")[0].querySelectorAll("a");
      for (let i = 0; i < tabs.length; i++) {
        tabs[i].removeAttribute("class");
        if (tabs[i].id === "scopes" || tabs[i].id === "sharepoint") {
          tabs[i].setAttribute("class", "orange-text text-darken-4");
        }
      }
    }
    let mobileTabs = document.getElementsByClassName("sidenav");
    if (mobileTabs.length > 0) {
      mobileTabs = mobileTabs[0].querySelectorAll("a");
      for (let i = 0; i < mobileTabs.length; i++) {
        if (
          mobileTabs[i].id === "scopesMobile" ||
          mobileTabs[i].id === "sharepointMobile"
        ) {
          mobileTabs[i].removeAttribute("class");
          mobileTabs[i].setAttribute(
            "class",
            "orange-text text-darken-4 grey darken-3"
          );
        }
      }
    }

    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions.bind(this));
  };

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  };

  render() {
    const { width } = this.state;
    const isMobile = width <= 600;
    const isTablet = width <= 992 && width > 600;
    return (
      <React.Fragment>
        <MetaDecorator
          title="JetMinds | SharePoint Dienstleister, Beratung, Konzeption und Entwicklung"
          descrption="Moderne Lösungen, die wir mit SharePoint Online für Ihr Firma erstellen können: Intranet, Dokumentbibliotheken, Datenbanken, Kalender- und Eventlisten, Websites und vieles mehr"
          url="https://www.jetminds.de/fokusbereiche/sharepoint-online/"
        />
        <div className="pageImageTitle">
          {isMobile ? (
            <img
              className="responsive-img"
              style={{ width: "100%" }}
              src={sharepointMobile}
              alt="JetMinds SharePoint Online"
              loading="lazy"
            />
          ) : (
            <img
              className="responsive-img"
              style={{ width: "100%" }}
              src={sharepoint}
              alt="JetMinds SharePoint Online"
              loading="lazy"
            />
          )}
          {isMobile || isTablet ? (
            <div className="imgTxtMobile">
              <h1
                className={`white-text ${isTablet ? "isTablet" : "isMobile"}`}
              >
                SharePoint Online
              </h1>
            </div>
          ) : (
            <div className="imgTxt">
              <h1 className="white-text">SharePoint Online</h1>
            </div>
          )}
        </div>

        <div className="container">
          <div className="section">
            <div className="row">
              <div className="col s12 m12">
                <h1 className={`${isMobile ? "pageTitleM" : "pageTitle"}`}>
                  <span className="orange-text text-darken-4">Stabile</span>{" "}
                  Zusammenarbeit,{" "}
                  <span className="orange-text text-darken-4">moderne</span> UI
                  und leistungsstarke Funktionen basierend auf{" "}
                  <span className="orange-text text-darken-4">
                    SharePoint Online
                  </span>
                </h1>
              </div>
            </div>
            <div className="row">
              <div className="col s12 m12">
                <p className="light">
                  Unsere Mission als End-to-End Dienstleister für moderne
                  Informationstechnologie und digitale Transformation ist es
                  Unternehmen und Organisationen zu ermöglichen, mehr mit der
                  Digitalisierung zu erreichen. Um dies zu realisieren, haben
                  wir unsere Entscheidung mit voller Überzeugung getroffen,
                  Microsoft SharePoint Online zu verwenden, um Unternehmen dabei
                  zu helfen, ihre digitalen Anforderungen zu erfüllen.
                </p>
                <p className="light">
                  SharePoint Online ist nicht nur ein Dokumentenmanagementsystem
                  (DMS) sondern es ist die Plattform, die allen Arten von
                  Organisationen und Unternehmen beeindruckende
                  Content-Erlebnisse und Teamwork-Services bietet. Es gibt die
                  Möglichkeit, Inhalte, Dateien und Listen intern sowie extern
                  mit Partnern und Anbietern auszutauschen. Zusätzlich steht
                  eine breite Palette von Diensten wie Websites,
                  Dokumentbibliotheken, Ereignislisten, Nachrichten, Dashboards
                  und viele andere nützliche Dienste bereit.
                </p>
                <p className="light">
                  SharePoint gibt es seit 2001 und wurde im Laufe der Zeit
                  kontinuierlich verbessert, sodass wir mit SharePoint Online
                  jetzt eine Version haben, die modern, leistungsstark und
                  sofort in der Cloud einsatzbereit ist. Hier haben wir Ihnen
                  einige der Highlights von SharePoint Online aufgelistet:
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="grey darken-3">
          <div className="container">
            {!isMobile && !isTablet ? (
              <div className="section">
                <div className="row center">
                  <div className="col s6 m3">
                    <div className="icon-block">
                      <h2 className="center white-text text-darken-4">
                        <i
                          className="material-icons"
                          style={{ fontSize: "35px" }}
                        >
                          cloud_done
                        </i>
                      </h2>
                      <p className="light white-text">
                        Cloud-basierte Plattform ohne Installation, physische
                        Vorbereitungen oder Hardware
                      </p>
                    </div>
                  </div>
                  <div className="col s6 m3">
                    <div className="icon-block">
                      <h2 className="center white-text text-darken-4">
                        <i
                          className="material-icons"
                          style={{ fontSize: "35px" }}
                        >
                          euro_symbol
                        </i>
                      </h2>
                      <p className="light white-text">
                        Reduzierte Startkosten, da keine zusätzlichen
                        Infrastrukturzahlungen anfallen
                      </p>
                    </div>
                  </div>
                  <div className="col s6 m3">
                    <div className="icon-block">
                      <h2 className="center white-text text-darken-4">
                        <i
                          className="material-icons"
                          style={{ fontSize: "35px" }}
                        >
                          system_update_alt
                        </i>
                      </h2>
                      <p className="light white-text">
                        Immer auf dem neuesten Stand, keine Updates und Patches
                        erforderlich
                      </p>
                    </div>
                  </div>
                  <div className="col s6 m3">
                    <div className="icon-block">
                      <h2 className="center white-text text-darken-4">
                        <i
                          className="material-icons"
                          style={{ fontSize: "35px" }}
                        >
                          color_lens
                        </i>
                      </h2>
                      <p className="light white-text">
                        Modernes Branding in einer responsiven Umgebung mit
                        flexiblen Templates
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row center">
                  <div className="col s6 m3">
                    <div className="icon-block">
                      <h2 className="center white-text text-darken-4">
                        <i
                          className="material-icons"
                          style={{ fontSize: "35px" }}
                        >
                          library_books
                        </i>
                      </h2>
                      <p className="light white-text">
                        Sehr gut konzipierte und erweiterbare Bibliotheken und
                        Listen mit Metadaten
                      </p>
                    </div>
                  </div>
                  <div className="col s6 m3">
                    <div className="icon-block">
                      <h2 className="center white-text text-darken-4">
                        <i
                          className="material-icons"
                          style={{ fontSize: "35px" }}
                        >
                          share
                        </i>
                      </h2>
                      <p className="light white-text">
                        Die Möglichkeit Daten sowohl intern als auch extern
                        freizugeben
                      </p>
                    </div>
                  </div>
                  <div className="col s6 m3">
                    <div className="icon-block">
                      <h2 className="center white-text text-darken-4">
                        <i
                          className="material-icons"
                          style={{ fontSize: "35px" }}
                        >
                          search
                        </i>
                      </h2>
                      <p className="light white-text">
                        Eine sehr leistungsstarke, übergreifende und performante
                        Suchmaschine
                      </p>
                    </div>
                  </div>
                  <div className="col s6 m3">
                    <div className="icon-block">
                      <h2 className="center white-text text-darken-4">
                        <i
                          className="material-icons"
                          style={{ fontSize: "35px" }}
                        >
                          web
                        </i>
                      </h2>
                      <p className="light white-text">
                        Sehr leistungsfähige Plattform zur Erstellung von
                        internen Websites
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            {isMobile ? (
              <div className="section">
                <div className="row center">
                  <div className="col s6">
                    <div className="icon-block">
                      <h2 className="center white-text text-darken-4">
                        <i
                          className="material-icons"
                          style={{ fontSize: "35px" }}
                        >
                          cloud_done
                        </i>
                      </h2>
                      <p className="light white-text">
                        Cloud-basierte Plattform ohne Installation, physische
                        Vorbereitungen oder Hardware
                      </p>
                    </div>
                  </div>
                  <div className="col s6">
                    <div className="icon-block">
                      <h2 className="center white-text text-darken-4">
                        <i
                          className="material-icons"
                          style={{ fontSize: "35px" }}
                        >
                          euro_symbol
                        </i>
                      </h2>
                      <p className="light white-text">
                        Reduzierte Startkosten, da keine zusätzlichen
                        Infrastrukturzahlungen anfallen
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row center">
                  <div className="col s6">
                    <div className="icon-block">
                      <h2 className="center white-text text-darken-4">
                        <i
                          className="material-icons"
                          style={{ fontSize: "35px" }}
                        >
                          system_update_alt
                        </i>
                      </h2>
                      <p className="light white-text">
                        Immer auf dem neuesten Stand, keine Updates und Patches
                        erforderlich
                      </p>
                    </div>
                  </div>
                  <div className="col s6">
                    <div className="icon-block">
                      <h2 className="center white-text text-darken-4">
                        <i
                          className="material-icons"
                          style={{ fontSize: "35px" }}
                        >
                          color_lens
                        </i>
                      </h2>
                      <p className="light white-text">
                        Modernes Branding in einer responsiven Umgebung mit
                        flexiblen Templates
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row center">
                  <div className="col s6">
                    <div className="icon-block">
                      <h2 className="center white-text text-darken-4">
                        <i
                          className="material-icons"
                          style={{ fontSize: "35px" }}
                        >
                          library_books
                        </i>
                      </h2>
                      <p className="light white-text">
                        Sehr gut konzipierte und erweiterbare Bibliotheken und
                        Listen mit Metadaten
                      </p>
                    </div>
                  </div>
                  <div className="col s6">
                    <div className="icon-block">
                      <h2 className="center white-text text-darken-4">
                        <i
                          className="material-icons"
                          style={{ fontSize: "35px" }}
                        >
                          share
                        </i>
                      </h2>
                      <p className="light white-text">
                        Die Möglichkeit Daten sowohl intern als auch extern
                        freizugeben
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row center">
                  <div className="col s6">
                    <div className="icon-block">
                      <h2 className="center white-text text-darken-4">
                        <i
                          className="material-icons"
                          style={{ fontSize: "35px" }}
                        >
                          search
                        </i>
                      </h2>
                      <p className="light white-text">
                        Eine sehr leistungsstarke, übergreifende und performante
                        Suchmaschine
                      </p>
                    </div>
                  </div>
                  <div className="col s6">
                    <div className="icon-block">
                      <h2 className="center white-text text-darken-4">
                        <i
                          className="material-icons"
                          style={{ fontSize: "35px" }}
                        >
                          web
                        </i>
                      </h2>
                      <p className="light white-text">
                        Sehr leistungsfähige Plattform zur Erstellung von
                        internen Websites
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            {isTablet ? (
              <div className="section">
                <div className="row center">
                  <div className="col s6 m4">
                    <div className="icon-block">
                      <h2 className="center white-text text-darken-4">
                        <i
                          className="material-icons"
                          style={{ fontSize: "35px" }}
                        >
                          cloud_done
                        </i>
                      </h2>
                      <p className="light white-text">
                        Cloud-basierte Plattform ohne Installation, physische
                        Vorbereitungen oder Hardware
                      </p>
                    </div>
                  </div>
                  <div className="col s6 m4">
                    <div className="icon-block">
                      <h2 className="center white-text text-darken-4">
                        <i
                          className="material-icons"
                          style={{ fontSize: "35px" }}
                        >
                          euro_symbol
                        </i>
                      </h2>
                      <p className="light white-text">
                        Reduzierte Startkosten, da keine zusätzlichen
                        Infrastrukturzahlungen anfallen
                      </p>
                    </div>
                  </div>
                  <div className="col s6 m4">
                    <div className="icon-block">
                      <h2 className="center white-text text-darken-4">
                        <i
                          className="material-icons"
                          style={{ fontSize: "35px" }}
                        >
                          system_update_alt
                        </i>
                      </h2>
                      <p className="light white-text">
                        Immer auf dem neuesten Stand, keine Updates und Patches
                        erforderlich
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row center">
                  <div className="col s6 m4">
                    <div className="icon-block">
                      <h2 className="center white-text text-darken-4">
                        <i
                          className="material-icons"
                          style={{ fontSize: "35px" }}
                        >
                          color_lens
                        </i>
                      </h2>
                      <p className="light white-text">
                        Modernes Branding in einer responsiven Umgebung mit
                        flexiblen Templates
                      </p>
                    </div>
                  </div>
                  <div className="col s6 m4">
                    <div className="icon-block">
                      <h2 className="center white-text text-darken-4">
                        <i
                          className="material-icons"
                          style={{ fontSize: "35px" }}
                        >
                          library_books
                        </i>
                      </h2>
                      <p className="light white-text">
                        Sehr gut konzipierte und erweiterbare Bibliotheken und
                        Listen mit Metadaten
                      </p>
                    </div>
                  </div>
                  <div className="col s6 m4">
                    <div className="icon-block">
                      <h2 className="center white-text text-darken-4">
                        <i
                          className="material-icons"
                          style={{ fontSize: "35px" }}
                        >
                          share
                        </i>
                      </h2>
                      <p className="light white-text">
                        Die Möglichkeit Daten sowohl intern als auch extern
                        freizugeben
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row center">
                  <div className="col s6 m4">
                    <div className="icon-block">
                      <h2 className="center white-text text-darken-4">
                        <i
                          className="material-icons"
                          style={{ fontSize: "35px" }}
                        >
                          search
                        </i>
                      </h2>
                      <p className="light white-text">
                        Eine sehr leistungsstarke, übergreifende und performante
                        Suchmaschine
                      </p>
                    </div>
                  </div>
                  <div className="col s6 m4">
                    <div className="icon-block">
                      <h2 className="center white-text text-darken-4">
                        <i
                          className="material-icons"
                          style={{ fontSize: "35px" }}
                        >
                          web
                        </i>
                      </h2>
                      <p className="light white-text">
                        Sehr leistungsfähige Plattform zur Erstellung von
                        internen Websites
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="container">
          <div className="section">
            <div className="row">
              <div className="col s12 m12">
                <h5>
                  Unsere{" "}
                  <span className="orange-text text-darken-4">
                    Servicepalette
                  </span>{" "}
                  im Bereich Microsoft{" "}
                  <span className="orange-text text-darken-4">
                    SharePoint Online
                  </span>
                </h5>
              </div>
            </div>
            <div className="row">
              <div className="col s12 m12">
                <p className="light">
                  Wenn es um das Thema SharePoint Online-Plattform geht, sind
                  wir mit Herz und Verstand bei der Sache. Unsere ausgiebige
                  Beratung beantwortet Ihre Fragen und unsere umfassenden
                  Dienstleistungen erfüllen Ihre speziellen Anforderungen. Durch
                  umfangreiche und erfolgreiche Projekte im Bereich SharePoint
                  Online haben wir praktische Erfahrungen gesammelt und ein
                  breites Verständnis für die Themen, die für die meisten
                  Unternehmen wichtig sind, erworben:
                </p>
              </div>
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="icon-block">
                  <h2 className="center orange-text text-darken-4">
                    <i className="material-icons" style={{ fontSize: "35px" }}>
                      business
                    </i>
                  </h2>
                  <h5 className="center">Beratung</h5>
                  <p className="light">
                    Sie befinden sich in der Planungsphase vor Ihrem nächsten
                    Schritt zum modernen Arbeitsplatz und zur digitalen
                    Zusammenarbeit basierend auf SharePoint Online. Haben Sie
                    hierzu offene Fragen? Geht es um Integration, Migration,
                    Sicherheit, Provisionierung, Administration, Entwicklung
                    oder Konfiguration? Wir stehen Ihnen mit fundierter
                    technischer sowie funktioneller Beratung rund um das Thema
                    SharePoint Online zur Seite.
                  </p>
                </div>
              </div>
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="icon-block">
                  <h2 className="center orange-text text-darken-4">
                    <i className="material-icons" style={{ fontSize: "35px" }}>
                      code
                    </i>
                  </h2>
                  <h5 className="center">Entwicklung</h5>
                  <p className="light">
                    Wir bieten Ihnen individuelle SharePoint Online Add-Ins
                    basierend auf Ihren Anforderungen. Wir sind der festen
                    Überzeugung, dass jedes Unternehmen eine einzigartige
                    SharePoint Solution, die seinen Bedürfnissen entspricht,
                    verdient. Deshalb beschränken wir unsere Arbeit nie auf die
                    Anpassung von Out-of-the-Box-Funktionen, sondern bieten
                    maßgeschneiderte Webparts, Branding, Architektur, Workflows
                    oder ein vollständiges Intranet an.
                  </p>
                </div>
              </div>
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="icon-block">
                  <h2 className="center orange-text text-darken-4">
                    <i className="material-icons" style={{ fontSize: "35px" }}>
                      sync
                    </i>
                  </h2>
                  <h5 className="center">Migration</h5>
                  <p className="light">
                    Wir helfen Ihnen bei Ihrem Wechsel zu SharePoint Online und
                    OneDrive in Microsoft 365. Es gibt verschiedene Tools und
                    Methoden, die wir bei der Migration verwenden können. Was
                    für Ihre Organisation am besten geeignet ist, hängt von
                    einer Reihe Faktoren ab: Die Datengröße, die Menge, die
                    Inhalte, die Datenquelle usw. Der Schlüssel zu einer
                    erfolgreichen Migration ist die Planung einschließlich der
                    Inventarisierung und Bewertung Ihrer Daten.
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="icon-block">
                  <h2 className="center orange-text text-darken-4">
                    <i className="material-icons" style={{ fontSize: "35px" }}>
                      power
                    </i>
                  </h2>
                  <h5 className="center">Support und Wartung</h5>
                  <p className="light">
                    Durch unsere mehrjährige Erfahrung mit SharePoint Online
                    können wir Ihre gewünschten Anforderungen verwirklichen.
                    Jedoch kann unsere Zusammenarbeit weiter geführt werden
                    durch unsere umfassenden Support- und Wartungsleistungen.
                    Wir kontrollieren kontinuierlich Ihre SharePoint Online
                    Umgebung und gewährleisten so eine robuste und fehlerfreie
                    Plattform für die Kollaboration und Kommunikation.{" "}
                  </p>
                </div>
              </div>
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="icon-block">
                  <h2 className="center orange-text text-darken-4">
                    <i className="material-icons" style={{ fontSize: "35px" }}>
                      import_export
                    </i>
                  </h2>
                  <h5 className="center">Integration</h5>
                  <p className="light">
                    Ein erfolgreicher, moderner Arbeitsplatz basierend auf
                    SharePoint Online, der mit den neuesten Technologien
                    ausgestattet ist, lässt sich mit Daten von anderen
                    Microsoft-Plattformen oder Drittanbietern problemlos
                    integrieren. Wir übernehmen alle Datenintegrationen und die
                    damit verbundenen Datenarchitekturen auf Basis von
                    SharePoint Online, um Ihnen die Integration in Ihre
                    SharePoint Online-Plattform zu verwirklichen.
                  </p>
                </div>
              </div>
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="icon-block">
                  <h2 className="center orange-text text-darken-4">
                    <i className="material-icons" style={{ fontSize: "35px" }}>
                      done_all
                    </i>
                  </h2>
                  <h5 className="center">Health Check</h5>
                  <p className="light">
                    Ihre SharePoint Online-Plattform sollte immer performant und
                    fehlerfrei sein. Wenn nicht, sollten Sie das nicht
                    ignorieren. Selbst geringfügige Probleme können Ihre
                    SharePoint-Plattform beschädigen und dazu führen, dass ein
                    benutzerfreundliches, reibungsloses Arbeiten nicht mehr
                    möglich ist. Wir bieten Ihnen den SharePoint Health Check
                    sowie Troubleshooting und Monitoring an, um die Effizienz
                    Ihrer Plattform zu analysieren.
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="icon-block">
                  <h2 className="center orange-text text-darken-4">
                    <i className="material-icons" style={{ fontSize: "35px" }}>
                      touch_app
                    </i>
                  </h2>
                  <h5 className="center">Provisionierung</h5>
                  <p className="light">
                    Da Arbeitsbereiche auf unterschiedliche Weise und an
                    unterschiedlichen Standorten erstellt werden können, kann
                    dies schnell außer Kontrolle geraten. Die Provisionierung
                    bezieht sich hier auf die automatische Erstellung und
                    Konfiguration von Arbeitsbereichen anstelle einer Person,
                    die die gesamte Arbeit manuell ausführt. Unter
                    Arbeitsbereichen verstehen wir Orte für die digitale
                    Zusammenarbeit, z. B. SharePoint Online-Websites, Microsoft
                    365 Gruppen sowie{" "}
                    <a
                      className="orange-text text-darken-4"
                      href="/fokusbereiche/microsoft-teams"
                    >
                      Teams
                    </a>{" "}
                    und TeamSites.
                  </p>
                </div>
              </div>
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="icon-block">
                  <h2 className="center orange-text text-darken-4">
                    <i className="material-icons" style={{ fontSize: "35px" }}>
                      security
                    </i>
                  </h2>
                  <h5 className="center">Administration</h5>
                  <p className="light">
                    Nur mit einer guten Administration können kleine,
                    mittelständige sowie große Unternehmen über ein eigenes
                    Unternehmensintranet verfügen. Die Administration von
                    SharePoint Online-Plattform soll die Zusammenarbeit
                    erleichtern und gewährleisten. Ihre Benutzer sollten in der
                    Lage sein, Dokumente, Kalender, Listen, Bilder,
                    Diskussionsforen und mehr, für Benutzer in Ihrem Netzwerk
                    und in einigen Fällen für Personen außerhalb Ihres
                    Netzwerks, wie Partner oder Vendors, freizugeben.
                  </p>
                </div>
              </div>
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="icon-block">
                  <h2 className="center orange-text text-darken-4">
                    <i className="material-icons" style={{ fontSize: "35px" }}>
                      settings
                    </i>
                  </h2>
                  <h5 className="center">Konfiguration</h5>
                  <p className="light">
                    Das Einrichten und Konfigurieren von SharePoint Online
                    Tenant mit den Best Practices beginnt, sobald Sie sich für
                    Microsoft 365 Tenant anmelden. Dabei gibt es verschiedene
                    Einstellungen, die Sie bei der Anmeldung für Microsoft 365
                    Tenant beachten sollten, um zu entscheiden, wie SharePoint
                    Online-Websites konfiguriert werden: Der physische
                    Speicherort des SharePoint Online-Rechenzentrums, Land und
                    Region, URL, Administratorkonten und Compliance-Richtlinien.
                  </p>
                </div>
              </div>
            </div>
            <div className="section">
              <div className="row center">
                <div className="col s12 m12">
                  <a href="/kontakt" className="btn-large orange darken-4">
                    Zur Kontaktanfrage
                    <i
                      className="material-icons right"
                      style={{ fontSize: "20px" }}
                    >
                      arrow_forward
                    </i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/layout/pages/SharePoint.js